import React, { useEffect, useState, useRef } from "react";
import { Toast } from 'primereact/toast';
import { BASE_API } from "../../api/Globals";
import { helpHttp } from "../../helpers/helpHttp";
import Loader from '../../components/sturtural/Loader';
import MessageDetail from '../../components/sturtural/MessageDetail';
import Menu from '../../components/sturtural/Menu';

const UsersAdmin = () => {
    const [db, setDb] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const toast = useRef();

    let url = `${BASE_API}user/internal`;

    useEffect(() => {
        setLoading(true);
        helpHttp().get(url).then((res) => {
            if (!res.err) {
                setDb(res.users);
                setError(null);
            } else {
                setDb(null);
                setError(res);
            }
            setLoading(false);
        });
    }, [url]);

    const showToast = (message, type = 'success') => {
        toast.current.show({ severity: type, summary: message, life: 3000 });
    };

    const handleChangePerfil = (event, usuarioid, perfil) => {
        helpHttp().post(`${BASE_API}user/changerol`, {
            body: {
                _perfilid: event.target.value,
                usuarioid: usuarioid,
                perfilid: perfil,
                sistemaid: 3,
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                "Access-Control-Allow-Origin": "*",
            },
        }).then((res) => {
            if (res.response === "on") {
                let data = res.user;
                handlerEdit(data[0])
                showToast(res.message);
            } else if (res.response === "off") {
                showToast(res.message, 'error');
            }
        });
    };

    const handleChangeStatus = (event, user) => {
        let statusid;
        if(user.statusid === 1) {
            statusid = 2;
        } else if(user.statusid === 2) {
            statusid = 1;
        }

        helpHttp().put(`${BASE_API}user/status`, {
            body: {
                usuarioid: user.usuarioid,
                statusid:  statusid
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                "Access-Control-Allow-Origin": "*",
            },
        }).then((res) => {
            if (res.response === "on") {
                let data = res.user;
                handlerEdit(data[0]);
                showToast(res.message);
            } else if (res.response === "off") {
                showToast(res.message, 'error');
            }
        });
    };

    const handlerEdit = (data) => {
        console.log(data);
        let newData = db.map((el) => 
            (el.usuarioid === data.usuarioid ? data : el)
        );
        setDb(newData);
    }

    const selectItemsPerfiles = [
        {
            code : 2,
            name : "ADMINISTRADOR",
        },
        {
            code : 3,
            name : "ARBITRO",
        },
        {
            code : 4,
            name : "VALIDADOR",
        },
        {
            code : 5,
            name : "REGISTRO",
        }
    ];

    return (
        <>
            <Menu link='nueva-solicitud' />
            
            <div className="grid">
                <Toast ref={toast} />
                <div className="col-12">
                    <div className="card">
                        <h5>Administración de usuarios</h5>
                        <p> En la siguiente lista, podrás activar, desactivar usuario y asignar el perfil correspondiente. </p>
                        <div className="grid grid-nogutter">
                            {loading && <div><Loader /></div>}
                            {!db && <MessageDetail color="warn" mensaje="NO SE ENCONTRARON USUARIOS REGISTRADOS" />}
                            {db && db.map((el, index) => (
                            <div className="col-12 md:col-6 xl:col-3 p-3" key={index}>
                                <div className="surface-card shadow-2 border-rounded p-3">
                                    <div className="flex flex-column align-items-center border-bottom-1 surface-border pb-3">
                                        <img src={(el.imagen == null ? 'assets/layout/images/users/user.png' : el.imagen)} className="mb-3" alt="1" style={{ width: "70px", height: "75px", borderRadius: "150px"}} />
                                        <span className="text-lg text-900 font-medium mb-2">
                                            {el.nombre} {el.primer_apellido} {el.segundo_apellido}
                                        </span>
                                        <span className="text-600 font-medium mb-2">
                                            {el.perfil}
                                        </span>
                                        <div>
                                            <span className="inline-block text-sm text-cyan-800 mr-1">
                                                {el.correo_electronico}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="flex pt-3">
                                        <div className="w-6 pr-2">
                                            <button onClick={(e) => handleChangeStatus(e, el)} value={el.statusid} className="p-button p-component p-button-outlined p-button-secondary w-full p-button-icon-only">
                                                {el.statusid === 1 ? "Activo" : "Inactivo"}
                                            </button>
                                        </div>
                                        <div className="w-6 pl-2">
                                            <select onChange={(e) => handleChangePerfil(e, el.usuarioid, el.perfilid)} style={{width: "100%", height: "100%", borderRadius: "4px", borderColor: "gray", color: "gray"}}>
                                                <option value="0">PERFIL</option>
                                                {selectItemsPerfiles.map((option, index) => (option.code !== el.perfilid ?
                                                    <option value={option.code} key={`option-${index}`}>{option.name}</option> : ''
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>))}
                        </div>
                    </div>
                </div>
            </div>
        </>
        );
    };

export default UsersAdmin;
